<div class="container-fluid">
    <app-header></app-header>
    <app-pages></app-pages>
    <app-footer></app-footer>
</div>